import { render, staticRenderFns } from "./ViewDocumento.vue?vue&type=template&id=6c7b9c2b"
import script from "./ViewDocumento.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewDocumento.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports